import { Button } from '@mui/material'
import React from 'react'

interface PropsType {
    children: React.ReactNode;
    color: string;
    width?: string;
    onClick: () => void;
    type?: string; //rounded (for border-radius)
    disabled?: boolean;
    height?: string;
    borderRadius?: string;
}

function OutlineButton({ children, color, onClick, width, type, disabled = false, height, borderRadius }: PropsType): JSX.Element {

    const handleClick = (): void => {
        onClick()
    }
       return (
        <>
            {
                color === "red" &&
                <Button
                    variant="outlined"
                    sx={{
                        background: '#fff',
                        borderRadius: type !== undefined ? '100px' : '',
                        color: '#D6242C',
                        padding: '0px 15px',
                        height: height !== undefined ? height : '40px',
                        fontSize: '14px',
                        fontWeight: '600',
                        transition: 'background 0.3s',
                        textTransform: 'none',
                        width: width !== undefined ? width : 'auto',
                        border: '1px solid #D6242C',
                        fontFamily: 'Manrope',
                        '&:hover': {
                            background: '#ffaeb2',
                            border: '1px solid #D6242C',
                        },
                    }}
                    onClick={handleClick}
                    disabled={disabled}
                >
                    {children}
                </Button>
            }
            {
                color === 'gray' &&
                <Button
                    variant="outlined"
                    sx={{
                        color: '#3A3A3A',
                        border: '1px solid #c4c4c4',
                        borderRadius: borderRadius !== undefined ? borderRadius : '50px',
                        fontSize: '14px',
                        textTransform: 'none',
                        fontFamily: 'Manrope',
                        background: '#FFF',
                        fontWeight: '600',
                        width: width !== undefined ? width : 'auto',
                        height: height !== undefined ? height : '40px',
                        '&:hover': {
                            background: '#e0e0e0',
                            border: '1px solid #e0e0e0',
                        }
                    }}
                    onClick={handleClick}
                    disabled={disabled}
                >
                    {children}
                </Button>
            }
        </>
    )
}

export default OutlineButton